export default "__VITE_ASSET__DRjfe9Fm__"